import { render, staticRenderFns } from "./CarouselWithPreview.vue?vue&type=template&id=85726520"
import script from "./CarouselWithPreview.vue?vue&type=script&lang=js"
export * from "./CarouselWithPreview.vue?vue&type=script&lang=js"
import style0 from "./CarouselWithPreview.vue?vue&type=style&index=0&id=85726520&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports